import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";

interface IconButtonProps {
    "data-testid"?: string;
    iconName: string;
    ariaLabel: string;
    onClick?: () => void;
    size?: string;
    hoverColor?: string;
    /**
     * Aligns the glyph to one edge while the tap target keeps its full width, so the icon can sit
     * flush with surrounding content instead of being inset by the target's free space.
     */
    iconAlignment?: "left" | "right";
}

const justifyClasses = {
    left: "justify-start",
    right: "justify-end",
} as const;

const IconButton = (props: IconButtonProps) => {
    const hoverClass = props.hoverColor ? `hover:${props.hoverColor}` : "";
    const iconClass = `${props.size ?? "text-xl"} text-p6-grey-dark ${hoverClass}`;
    const justifyClass = props.iconAlignment ? justifyClasses[props.iconAlignment] : "justify-center";

    return (
        <button
            type="button"
            aria-label={props.ariaLabel}
            data-testid={props["data-testid"]}
            onClick={props.onClick}
            className={`flex items-center ${justifyClass} min-w-[44px] min-h-[44px] bg-transparent border-none cursor-pointer p-no`}
        >
            <PhaseSixIcon
                name={props.iconName}
                className={iconClass}
            />
        </button>
    );
};

export default IconButton;
